import { Toast } from '@assembly-web/ui';

import { useToastStore } from '../stores/useToastStore';

export function ToastContainer() {
  const { kind, message, isToastOpen, hideToast } = useToastStore();

  return isToastOpen ? (
    <Toast kind={kind} message={message} onCloseToastClick={hideToast} />
  ) : null;
}
